export enum HelloSignWizardStep {
  FORM_STEP = 1,
  SUMMARY_STEP = 2,
}

// i.e 9175b5bc-c7b6-5650-9cbf-2c77a364f383
// i.e d7e7bf34-c23b-4a81-80ce-731f41b33088 (case insensitive)
export const UUID_REGEX =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
// i.e. ?query=param&another=param
export const QUERY_PARAM_REGEX = /(\?|&)([^=]+)=([^&]+)$/g;

export const PRODUCTS = {
  CASH_OFFER: 'Cash offer',
  CASH_PLUS: 'Cash Plus',
  // LIST_WITH_OPENDOR: 'List', // Needs to be localized: 'Poner a la venta'
} as const;

// from bricks novo theme
export const BOX_SHADOW_Z2 =
  '0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)';
